import type { IconDefinition } from '../index.tsx';

export const iconTwitter: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconTwitter',
  icon: [
    16,
    16,
    [],
    '',
    'M14.3594 4.73438C14.3594 4.89062 14.3594 5.01562 14.3594 5.17188C14.3594 9.51562 11.0781 14.4844 5.04688 14.4844C3.17188 14.4844 1.45312 13.9531 0.015625 13.0156C0.265625 13.0469 0.515625 13.0781 0.796875 13.0781C2.32812 13.0781 3.73438 12.5469 4.85938 11.6719C3.42188 11.6406 2.20312 10.7031 1.79688 9.39062C2.01562 9.42188 2.20312 9.45312 2.42188 9.45312C2.70312 9.45312 3.01562 9.39062 3.26562 9.32812C1.76562 9.01562 0.640625 7.70312 0.640625 6.10938V6.07812C1.07812 6.32812 1.60938 6.45312 2.14062 6.48438C1.23438 5.89062 0.671875 4.89062 0.671875 3.76562C0.671875 3.14062 0.828125 2.57812 1.10938 2.10938C2.73438 4.07812 5.17188 5.39062 7.89062 5.54688C7.82812 5.29688 7.79688 5.04688 7.79688 4.79688C7.79688 2.98438 9.26562 1.51562 11.0781 1.51562C12.0156 1.51562 12.8594 1.89062 13.4844 2.54688C14.2031 2.39062 14.9219 2.10938 15.5469 1.73438C15.2969 2.51562 14.7969 3.14062 14.1094 3.54688C14.7656 3.48438 15.4219 3.29688 15.9844 3.04688C15.5469 3.70312 14.9844 4.26562 14.3594 4.73438Z',
  ],
};
